module.exports = __webpack_public_path__ + "img/plane_map.baa15ede.svg";